import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const checkIfLiked = async (userId, reviewId) => {
  const { data, error } = await supabase
    .from('salon_review_likes')
    .select('id')
    .eq('user_id', userId)
    .eq('review_id', reviewId)
    .single();

  if (error) {
    console.error('Ошибка при проверке лайка:', error);
    return false;
  }

  return !!data;
};

export default function useCheckIfSalonLiked(userId, reviewId) {
  return useQuery({
    queryKey: ['useCheckIfSalonLiked', userId, reviewId],
    queryFn: () => checkIfLiked(userId, reviewId),
    staleTime: 0,
  });
}
